import React from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import {
  SwitchQuote,
  SwitchQuoteText,
  SwitchQuoteAuthor,
  SwitchQuotePodcast,
} from '../../styles';

export function QuotesEn() {
  const t = useT();
  return (
    <>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/en/pretty-big-deal-cover"
          alt="Pretty Big Deal with Ashley Graham podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor>Ashley Graham</SwitchQuoteAuthor>
        <SwitchQuotePodcast>Pretty Big Deal</SwitchQuotePodcast>
        <SwitchQuoteText>
          {t(
            'ImportScreen.SwitchQuotesSection.AshleyGrahamQuote',
            "“The show has given me the opportunity to talk to the most incredible guests and share these real, candid conversations with our audience. I love how through the podcast, I've been able to learn something new and hear other perspectives.”",
            'Switch to Anchor page podcaster experience using Anchor quote'
          )}
        </SwitchQuoteText>
      </SwitchQuote>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/en/genius-brain-cover"
          alt="Genius Brain with David So podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor>David So</SwitchQuoteAuthor>
        <SwitchQuotePodcast>Genius Brain</SwitchQuotePodcast>
        <SwitchQuoteText>
          {t(
            'ImportScreen.SwitchQuotesSection.DavidSoQuote',
            "“Anchor is one of the easiest user-friendly platforms I've used for podcasting. It's straightforward, intuitive, and the Ad features make it easy to integrate into my podcasts!”",
            'Switch to Anchor page podcaster experience using Anchor quote'
          )}
        </SwitchQuoteText>
      </SwitchQuote>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/en/rumble-cover"
          alt="Rumble with Michael Moore podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor>Michael Moore</SwitchQuoteAuthor>
        <SwitchQuotePodcast>Rumble</SwitchQuotePodcast>
        <SwitchQuoteText>
          {t(
            'ImportScreen.SwitchQuotesSection.MichaelMooreQuote',
            "“Anchor believes in the democratization of audio, pure and simple, and because of that, that's why I use this platform... Now, more than ever, our voices need to be heard.”",
            'Switch to Anchor page podcaster experience using Anchor quote'
          )}
        </SwitchQuoteText>
      </SwitchQuote>
    </>
  );
}
